import React from 'react';
import {
  IconButton,
  Grid,
  TextField
} from '@material-ui/core';
import { CancelOutlined } from '@material-ui/icons';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsRow: {
    marginBottom: '12px',
  }
}))

const EmploymentHistoryFields = (props) => {
  const classes = useStyles();

  const { id, attributes, _destroy } = props.employment;

  const handleNestedFieldChange = (event, item) => {
    props.onChange(event, item, 'employmentHistory');
  }

  const handleRemoveEmployment = (employment) => {
    props.onClick(employment, 'employmentHistory');
  }

  const handleDateChange = (date, field, employment) => {
    const event = {
      target: {
        name: field,
        type: 'date',
        value: date,
      }
    }

    props.onChange(event, employment, 'employmentHistory');
  }

  const renderFields = (attributes) => {
    return (
      <React.Fragment>
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextField
            fullWidth
            label="Company"
            name="contact_employment_history_company_name"
            onChange={(event) => handleNestedFieldChange(event, props.employment)}
            value={attributes.contact_employment_history_company_name}
            variant="outlined"
          />
        </Grid>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Grid
            item
            md={3}
            xs={12}
          >
            <DatePicker
              name="contact_employment_history_start_date"
              label="Start Date"
              inputVariant="outlined"
              fullWidth
              format='MMM DD, YYYY'
              value={attributes.contact_employment_history_start_date}
              onChange={(date) => handleDateChange(date, 'contact_employment_history_start_date', props.employment)}
            />
          </Grid>

          <Grid
            item
            md={3}
            xs={12}
          >
            <DatePicker
              name="contact_employment_history_end_date"
              label="End Date"
              inputVariant="outlined"
              fullWidth
              format='MMM DD, YYYY'
              value={attributes.contact_employment_history_end_date}
              onChange={(date) => handleDateChange(date, 'contact_employment_history_end_date', props.employment)}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextField
              fullWidth
              label="City"
              name="contact_employment_history_location_city"
              onChange={(event) => handleNestedFieldChange(event, props.employment)}
              value={attributes.contact_employment_history_location_city}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextField
              fullWidth
              label="State"
              name="contact_employment_history_location_state"
              onChange={(event) => handleNestedFieldChange(event, props.employment)}
              value={attributes.contact_employment_history_location_state}
              variant="outlined"
            />
          </Grid>
        </MuiPickersUtilsProvider>
      </React.Fragment>
    )
  }

  const renderDisabledFields = (attributes) => {
    return (
      <React.Fragment>
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextField
            fullWidth
            disabled={attributes.from_file}
            label="Company"
            name="contact_employment_history_company_name"
            onChange={(event) => handleNestedFieldChange(event, props.employment)}
            value={attributes.contact_employment_history_company_name}
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextField
            fullWidth
            disabled={attributes.from_file}
            label="Start Date"
            name="contact_employment_history_start_date"
            onChange={(event) => handleNestedFieldChange(event, props.employment)}
            value={attributes.contact_employment_history_start_date}
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextField
            fullWidth
            disabled={attributes.from_file}
            label="End Date"
            name="contact_employment_history_end_date"
            onChange={(event) => handleNestedFieldChange(event, props.employment)}
            value={attributes.contact_employment_history_end_date || 'Present'}
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextField
            fullWidth
            disabled={attributes.from_file}
            label="City"
            name="contact_employment_history_location_city"
            onChange={(event) => handleNestedFieldChange(event, props.employment)}
            value={attributes.contact_employment_history_location_city}
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextField
            fullWidth
            disabled={attributes.from_file}
            label="State"
            name="contact_employment_history_location_state"
            onChange={(event) => handleNestedFieldChange(event, props.employment)}
            value={attributes.contact_employment_history_location_state}
            variant="outlined"
          />
        </Grid>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {_destroy ? null : (
        <Grid container spacing={3} key={id} className={classes.fieldsRow}>
          {attributes.from_file ? renderDisabledFields(attributes) : renderFields(attributes)}

          <Grid
            item
            md={3}
            xs={12}
          >
            {attributes.from_file ? null : <IconButton
              color="primary"
              variant="contained"
              onClick={(event) => handleRemoveEmployment(props.employment)}
            >
              <CancelOutlined />
            </IconButton>}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  )
}

EmploymentHistoryFields.propTypes = {
  employment: PropTypes.object,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
};

export default EmploymentHistoryFields;